import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "pb-0"
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "hide-details": "auto",
      "single-line": "",
      "clearable": "",
      "dense": ""
    },
    model: {
      value: _vm.searchItem,
      callback: function ($$v) {
        _vm.searchItem = $$v;
      },
      expression: "searchItem"
    }
  })], 1)], 1), _c(VDataTable, {
    staticClass: "row-pointer",
    attrs: {
      "items": _vm.filteredList,
      "loading": _vm.isFetching,
      "options": _vm.tableOptions,
      "search": _vm.searchItem,
      "headers": _vm.tableLocalizations.headers,
      "footer-props": _vm.tableLocalizations.tableFooterProps,
      "expanded": _vm.expandedItems,
      "item-key": "id"
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      },
      "current-items": _vm.getFiltered
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (items) {
        return [_c('tr', {
          on: {
            "click": function ($event) {
              return _vm.handleClickDevice(items.item);
            }
          }
        }, [_c('td', [items.item.battery_alert_status ? _c(VIcon, {
          attrs: {
            "color": _vm.getColor('error'),
            "small": ""
          }
        }, [_vm._v("\n            fal fa-battery-slash\n          ")]) : _vm._e(), !items.item.battery_alert_status && items.item.battery_warning_status ? _c(VIcon, {
          attrs: {
            "color": _vm.getColor('warning'),
            "small": ""
          }
        }, [_vm._v("\n            fal fa-battery-slash\n          ")]) : _vm._e(), !items.item.battery_alert_status && !items.item.battery_warning_status && items.item.threshold > items.item.packetCount ? _c(VIcon, {
          attrs: {
            "color": _vm.getColor('error'),
            "small": ""
          }
        }, [_vm._v("\n            fal fa-sensor-alert\n          ")]) : _vm._e()], 1), _c('td', {
          staticClass: "px-0 text-center",
          staticStyle: {
            "width": "70px"
          }
        }, [_vm._v(_vm._s(items.item.id))]), _c('td', [_c('router-link', {
          attrs: {
            "to": `/niota-classic/devices/${items.item.id}/details`
          }
        }, [_vm._v("\n            " + _vm._s(items.item.title) + "\n          ")])], 1), _c('td', [_vm.isCopySupported() ? _c('div', {
          staticClass: "euiElement",
          on: {
            "click": function ($event) {
              return _vm.copyToClipboard($event, items.item.eui);
            }
          }
        }, [_c('pre', [_vm._v(_vm._s(items.item.eui))]), _c(VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-copy")])], 1) : _c('div', {
          staticClass: "euiElement"
        }, [_c('pre', [_vm._v(_vm._s(items.item.eui))])])]), _c('td', [_vm._v("\n          " + _vm._s(items.item.applicationTitle) + "\n        ")]), _c('td', [_vm._v("\n          " + _vm._s(items.item.additionalInformation) + "\n        ")]), _c('td', [_vm._v(_vm._s(_vm.localizeDate(items.item.lastPacket)))]), _c('td', [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.openDetails(items.item);
            }
          }
        }, [_vm._v("fal fa-eye")])], 1)])];
      }
    }, {
      key: "expanded-item",
      fn: function (props) {
        return [_c('tr', [_c('td', {
          attrs: {
            "colspan": "7"
          }
        }, [_c(VRow, [_c(VCol, {
          attrs: {
            "col": "12"
          }
        }, [_c('div', {
          staticClass: "px-2 pb-2 highlighted"
        }, [_c('p', {
          staticClass: "text-overline pt-1 mb-0 grey--text"
        }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceMonitoring.status')) + "\n                ")]), props.item.battery_alert_status ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceMonitoring.alert')) + ":\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceMonitoring.alertMsg')) + "\n                ")]) : _vm._e(), !props.item.battery_alert_status && props.item.battery_warning_status ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceMonitoring.warning')) + ":\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceMonitoring.warningMsg')) + "\n                ")]) : _vm._e(), !props.item.battery_alert_status && !props.item.battery_warning_status && props.item.threshold > props.item.packetCount ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceMonitoring.alert')) + ":\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceMonitoring.thresholdAlertMsg')) + "\n                ")]) : _vm._e()])]), props.item.accountId ? _c(VCol, {
          attrs: {
            "col": "12"
          }
        }, [_c('div', {
          staticClass: "px-2 pb-2 highlighted"
        }, [_c('p', {
          staticClass: "text-overline pt-1 mb-0 grey--text"
        }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceMonitoring.account')) + "\n                ")]), _vm._v("\n                " + _vm._s(props.item.accountName) + " (" + _vm._s(`ÌD: ${props.item.accountId}`) + ")\n              ")])]) : _vm._e()], 1)], 1)])];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_c(VRow, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n          " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n        ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptions.page,
            "table-max-items": _vm.serverItemsLength,
            "table-items-per-page": _vm.tableOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          },
          on: {
            "page-change": function ($event) {
              return _vm.setCurrentTablePage($event);
            }
          }
        })], 1)], 1)];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n        " + _vm._s(_vm.apiError ? _vm.apiError : _vm.$i18n_t('NiotaClassic.DeviceMonitoring.noWarnings')) + "\n      ")])];
      },
      proxy: true
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };